import type { StudioSnapshot as SchemaSnapshot, Resource } from '../../../src/ontology/studio-model';
import type { TenantModel } from '../../../src/ontology/tenant-model';
export type StudioSnapshot = SchemaSnapshot & { tenant?: TenantModel };
export type { Resource };
export async function studioRequest<T>(path = '', init: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('novax:token');
  const response = await fetch(`/api/ontology/studio${path}`, { ...init, headers: { Authorization: `Bearer ${token || ''}`, 'Content-Type': 'application/json', ...init.headers } });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(response.status === 401 ? '登录已过期，请返回 NovaX 登录后重试。' : body.error || '本体请求失败');
  return body;
}
export function studioUrl(resource?: Resource, kind?: string) {
  const query = new URLSearchParams();
  if (resource) query.set('resource', resource.id);
  if (kind) query.set('kind', kind);
  return `/web/ontology-studio.html${query.size ? `?${query}` : ''}`;
}
